<template>
    <v-layout row wrap justify-space-between>
        <!-- Header -->
        <v-flex xs12 sm12 md12 lg12 xl12>
            <PageTitle icon="mdi-view-dashboard" main="Dashboard" sub="Estatísticas" />
        </v-flex>
        
        <!-- Filters -->
        <v-flex xs12 sm12 md12 lg12 xl12>
            <Filters/>
        </v-flex>

        <!-- Automations -->
        <v-flex xs12 sm12 md12 lg12 xl12>
           <Automations/>
        </v-flex>
      
        <!-- Downloads -->
        <!-- <v-flex xs12 sm12 md12 lg12 xl12>
           <Downloads/>
        </v-flex> -->
    </v-layout>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Filters from './Filters'
import Automations from './Automations'
import Downloads from './Downloads'

export default {
    name: 'Home',
    components: { PageTitle, Filters, Automations, Downloads },
    data: function() {
        return {
            registers: []
        }
    },
}
</script>

<style>
</style>
